import { useToasts } from '../../../cdl/Toast/useToasts';
import { translate } from '../../helpers/translate.helper';
import { IconNews } from '../../icons/cdl/News';
import { useShortcutMenu } from '../hooks/useShortcutMenu';

import { CommandItem } from './CommandItem';

export const OpenChangelog = () => {
    const { addErrorToast } = useToasts();
    const { setOpen } = useShortcutMenu();

    return (
        <CommandItem
            onSelect={() => {
                if (window.Productlane) {
                    window.Productlane.toggle();
                } else {
                    addErrorToast(translate('global.genericError'));
                }

                setOpen(false);
            }}
            Icon={IconNews}
        >
            {translate('navigation.changelog')}
        </CommandItem>
    );
};
